


























import { computed, defineComponent } from '@vue/composition-api'
import I18n from '@/locales/I18n'

export default defineComponent({
  name: 'MypageSelectPlanButtonParts',
  props: {
    /**
     * 商品名
     */
    name: {
      type: String,
      default: '',
    },
    /**
     * 価格
     */
    price: {
      type: String,
      default: '',
    },
    /**
     * 価格（ボタンに表示する用）
     */
    priceForButton: {
      type: String,
      default: '',
    },
    /**
     * 支払い単位（サイクル）
     */
    unit: {
      type: String,
      default: '',
    },
    /**
     * お得額
     */
    bargainPriced: {
      type: String,
    },
    /**
     * 12で割った年額プランの価格
     */
    annualPlanPriceDividedBy12: {
      type: String,
    },
    /**
     * ノート
     */
    note: {
      type: String,
    },
    /**
     * 契約期間
     */
    period: {
      type: String,
      default: '',
    },
    /**
     * トライアルかどうか
     */
    isEligibleTrialPlan: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const handleClicked = () => {
      emit('onClick')
    }

    const priceShowOnTrial = computed(() => {
      if (props.annualPlanPriceDividedBy12) {
        // 年額プランの場合の処理
        return I18n.t('MypagePage.MypageSwitchToPaidPlanPage.plans.annual.priceShowOnTrial', {
          price: props.price,
          priceDividedBy12: props.annualPlanPriceDividedBy12,
        }).toString()
      }

      // 月額プランの場合の処理
      return I18n.t('MypagePage.MypageSwitchToPaidPlanPage.plans.monthly.priceShowOnTrial', {
        price: props.price,
      }).toString()
    })

    return {
      handleClicked,
      priceShowOnTrial,
    }
  },
})
